import {KeyLabel} from './key-label.model';
export enum AdsTxtStatus {
  NOT_EXIST = 'NOT_EXIST', // -> NO_FILE on UI
    // INVALID = 'INVALID', // should be hidden on UI
  INCOMPLETE = 'INCOMPLETE', // exists at least one consumable record
  NO_RECORDS = 'NO_RECORDS', // no consumable records
  VALID = 'VALID'

}

export const AdsTxtStatusLabels = {
  VALID: 'Valid',
  // INVALID: 'Invalid',
  INCOMPLETE: 'Partial',
  NOT_EXIST: 'No file',
  NO_RECORDS: 'No records'
};

export const AdsTxtStatusLabelKL = () =>
  (Object.keys(AdsTxtStatusLabels).map(key => new KeyLabel<AdsTxtStatus>(<AdsTxtStatus>key, AdsTxtStatusLabels[key])));
